// deps
import React from "react";

// styles
import { Container, TextContainer } from "./GroupCartTopBanner.style";

// components
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// helpers
import { isEmpty } from "@swiggy-private/js-utils";

// internal-deps
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types";

// data-testids
import { GROUP_CART_ORDER_DATA_TEST_IDS } from "@swiggy-private/cart-test-ids";

export interface IProps {
    bgColor?: keyof IColors;
    leftAssetCloudinaryId?: string;
    title?: string;
    subtitle?: string;
}

const BannerIconDimensions = {
    width: "20px",
    height: "20px",
};

const GroupCartTopBanner: React.FC<IProps> = ({ bgColor, leftAssetCloudinaryId, title, subtitle }: IProps) => {
    return (
        <Container bgColor={bgColor} data-testid={GROUP_CART_ORDER_DATA_TEST_IDS.GUEST_BANNER}>
            {!isEmpty(leftAssetCloudinaryId) && (
                <Image
                    cloudinaryId={leftAssetCloudinaryId}
                    {...BannerIconDimensions}
                    alt="groupcart-guestbanner-icon"
                />
            )}
            <TextContainer>
                <Text variant="V2.body2.neutral.bold">{title}</Text>
                <Text variant="V2.body2.neutral.regular">{subtitle}</Text>
            </TextContainer>
        </Container>
    );
};

export default React.memo(GroupCartTopBanner);
